var $ = require('../modules/jquery');
var enquire = require('../modules/enquire');

/**
 * namespacing in less offensive way to jquery gods
 */
var NcCourtsPanelFilter = {
  init: function (Drupal, drupalSettings) {

    // Initializations
    // ---------------------------------------------------------------------------
    enquire.register("screen and (max-width: 1023px)", {

      // Triggered when a media query matches.
      match: function () {
        NcCourtsPanelFilter.initFilterPanel();
      },

      // Triggered when the media query transitions
      // *from a matched state to an unmatched state*.
      unmatch: function () {
        NcCourtsPanelFilter.destroyFilterPanel();
      }

    });

    // setup filter form autosubmit and filter settings header
    this.handleFilterEvents();
    this.getTagFilterFromQueryString(false);

    this.initPseudoPublicationsFilterUI()
            .then(function (pseudoSelect) {
              NcCourtsPanelFilter.getTagFilterFromQueryString(pseudoSelect);
              // reupdate just for this one
              NcCourtsPanelFilter.setFilterSettings();
            });

    // do one more filter update just in case
    this.setFilterSettings();
  }
};

NcCourtsPanelFilter.setFilterSettings = function () {
  var elem = $('.form--filter-panel');

  // build filter settings text

  var filterSettings = '';

  $.each(elem.find('input.form-text'), function (index, field) {
    // check search field filter
    var searchField = $(field);

    if (searchField.val().length > 0

            && typeof searchField.val() !== typeof undefined
            && searchField.data('speech')) {
      filterSettings += searchField.data('speech')
              + ' <span>'
              + searchField.val()
              + '</span>, ';

    }
  });

  // check select list filters
  $.each(elem.find('select.form-select'), function (index, field) {
    var selectList = $(field);
    var selectedText = $(field).find('option:selected').text();
    if (selectedText !== Drupal.t('- Any -')) {
      var speechAttr = selectList.data('speech');
      if (
              (typeof speechAttr !== typeof undefined && speechAttr !== false)
              &&
              (typeof selectedText !== typeof undefined)
              ) {
        filterSettings += selectList.data('speech')
                + ' <span>'
                + selectedText
                + '</span>, ';
      }
    }
  });

  // radio button filters
  $.each(elem.find('input.form-radio'), function (index, field) {
    var radioButton = $(field);
    var radioButtonValue = radioButton.val();
    if (radioButton.is(':checked')) {

      var speech = radioButton.parents('fieldset').data('speech');

      if (speech && radioButtonValue !== "All")
        filterSettings += speech
                + ' <span>'
                + radioButton.next('label').text()
                + '</span>, ';
    }
  });

  // trim and remove trailing ',' from filter settings text
  filterSettings = filterSettings.trim().replace(/,$/g, "");
  var listHeader = $('#title--contextual');

  if (listHeader.length > 0) {
    if (listHeader.find('.filter-settings').length === 0)
    {
      listHeader.append('<div class="filter-settings" />')
    }

  }

  listHeader.find('.filter-settings').html(filterSettings);
};


NcCourtsPanelFilter.initFilterPanel = function () {

  // variables
  var elem = $('.form--filter-panel');
  var $filter_panel_button = $('<button>');

  // add body class
  $('body').addClass('has-filter-panel');

  // setup wrappers
  elem.wrap('<div class="filter-panel">');
  elem.wrap('<div class="filter-panel__content" aria-hidden="true">');

  $filter_panel_button.attr('class', 'filter-panel__title')
          .attr('aria-expanded', 'false')
          .html(Drupal.t('Filter results'));

  $('.filter-panel').prepend($filter_panel_button);

  // toggle panel
  $('body').on('click', '.filter-panel__title', function () {

    var expanded = $(this).attr('aria-expanded');

    // toggle body clip
    $('body').toggleClass('clipped');

    // toggle aria attributes for accessibility
    if (expanded === 'false') {
      $(this).attr('aria-expanded', 'true');
      $(this).next().attr('aria-hidden', 'false');
    } else {
      $(this).attr('aria-expanded', 'false');
      $(this).next().attr('aria-hidden', 'true');
    }

    // toggle class
    $(this).parent().toggleClass('filter-panel--active');

  });

};

NcCourtsPanelFilter.destroyFilterPanel = function () {

  // unbind actions
  $('body').off('click', '.filter-panel__title');

  // remove wrappers
  $('.form--filter-panel').insertAfter('.filter-panel');
  $('.filter-panel').remove();

  // remove body class
  $('body').removeClass('clipped');
  $('body').removeClass('has-filter-panel');
};

// update filter settings text and refresh view list
NcCourtsPanelFilter.updateResults = function () {
  var submitButton = $('.form--filter-panel').find('input.form-submit');
  // flag focused field
  $(document.activeElement).addClass('restore-focus');
  this.setFilterSettings();
  // submit filter form
  submitButton.trigger('click');
};

NcCourtsPanelFilter.initPseudoPublicationsFilterUI = function () {
  var $elem = $('.form--filter-panel');
  var $pseudoSelectContainer = $elem.find('div[data-organization-combined-select-filter]').first();
  var $pseudoSelect = $elem.find('#filter-organization-combined-select-filter').first();

  var $commissionSelect = $elem.find('select[name="field_commission_target_id"]').first();
  var $commissionsOptGroup = $('<optgroup>').attr('label', Drupal.t('Commissions'));

  var $programSelect = $elem.find('select[name="field_program_target_id"]').first();
  var $programOptGroup = $('<optgroup>').attr('label', Drupal.t('Programs'));

  var $organizationSelect = $elem.find('select[name="field_other_organization_target_id"]').first();
  var $organizationOptGroup = $('<optgroup>').attr('label', Drupal.t('Other organizations'));


  // move dropdown after publication dropdown
  $pseudoSelectContainer.insertAfter($('.form-item-field-publication-type-target-id'));

  function getValues($select) {
    var $options = $('option', $select);
    return $options.map(function (index, option) {
      return {
        'text': option.text,
        'value': option.value
      };
    });
  }

  function buildOptionGroup(name, values, $group, currentValue) {

    values.map(function (i, option) {
      var $option = $('<option></option>');
      if ("All" !== option.value) {
        $option.attr('value', name + ':' + option.value)
                .attr('selected', 'All' !== currentValue && option.value === currentValue)
                .text(option.text);
        $group.append($option);
      }
    });
  }

  buildOptionGroup("commission", getValues($commissionSelect), $commissionsOptGroup, $commissionSelect.val());
  buildOptionGroup("program", getValues($programSelect), $programOptGroup, $programSelect.val());
  buildOptionGroup("organization", getValues($organizationSelect), $organizationOptGroup, $organizationSelect.val());

  $pseudoSelect
          .append($commissionsOptGroup)
          .append($programOptGroup)
          .append($organizationOptGroup);

  $pseudoSelect.change(function () {

    var selectedValue = $(this).val();

    // clear all selects
    $programSelect.val(['All']);
    $commissionSelect.val(['All']);
    $organizationSelect.val(['All']);

    if ("All" !== selectedValue) {
      selectedValue = selectedValue.split(':');
      var select = selectedValue[0];
      var value = selectedValue[1];

      switch (select) {
        case "program":
          $programSelect.val($.makeArray(value));
          break;
        case "commission":
          $commissionSelect.val($.makeArray(value));
          break;
        case "organization":
          $commissionSelect.val($.makeArray(value));
          break;
      }
    }

    // update results once for all changes
    NcCourtsPanelFilter.updateResults();
  });

  return Promise.resolve($pseudoSelect);
};


NcCourtsPanelFilter.handleFilterEvents = function () {
  var elem = $('.form--filter-panel');
  var searchField = elem.find('input.form-text');
  var selectLists = elem.find('select.form-select');
  var radioButtons = elem.find('input.form-radio');
  var typingTimeout = {};

  // refresh view list when there has been a typing pause of 1 sec in the
  // search field.
  searchField.keyup(function () {
    clearTimeout(typingTimeout);
    typingTimeout = setTimeout(function () {
      NcCourtsPanelFilter.updateResults();
    }, 1000);
  });

  // refresh view list when a select list has changed
  selectLists.change(function () {
    NcCourtsPanelFilter.updateResults();
  });

  radioButtons.change(function () {
    NcCourtsPanelFilter.updateResults();
  });

  // restore focus to filter
  // field when ajax request has completed
  $(document).ajaxComplete(function () {
    NcCourtsPanelFilter.setFilterSettings()
    $('.restore-focus').removeClass('restore-focus').focus();
  });
};

/**
 * Stolen from https://stackoverflow.com/a/21152762/912087
 * 
 * modified to handle *simple* arrays
 * 
 * @returns {Array|Object}
 */
NcCourtsPanelFilter.queryStringToJSON = function () {
  var qd = {};
  if (location.search)
    $.each(location.search.substr(1).split("&"), function (index, item) {
      var s = item.split("="),
              k = decodeURIComponent(s[0]),
              v = s[1] && decodeURIComponent(s[1]);
      var hasArray = k.replace(/\[\]$/, '');
      if (k !== hasArray)
      {
        (qd[hasArray] = qd[hasArray] || []).push(v);
      } else
      {
        qd[k] = v;
      }

    });
  return qd;
};

// Returns querystring value from key
NcCourtsPanelFilter.getQueryStringParameterByName = function (name) {

  var qs = this.queryStringToJSON();

  return (qs.hasOwnProperty(name)) ? qs[name] : '';

};

// Inits filter input from querystring.
NcCourtsPanelFilter.getTagFilterFromQueryString = function ($pseudoSelect) {
  var hasPseudoSelect = ($pseudoSelect.length > 0);
  var query = this.queryStringToJSON();
  var vocabulary_id = this.getQueryStringParameterByName('vid');
  var term_id = this.getQueryStringParameterByName('tid');

  if (
          (vocabulary_id !== null && vocabulary_id !== '')
          &&
          (term_id !== null && term_id !== '')
          ) {

    // set the pseudo select
    if (hasPseudoSelect) {

      $pseudoSelect.val($.makeArray(vocabulary_id + ":" + term_id));

    }

    // and also update hidden stuff.
    var $select = $('[name=field_' + vocabulary_id + '_target_id]');
    $select.val($.makeArray(term_id));

    this.updateResults();

  }
  // else do the reverse.
  else
  {
    $.each(query, function (key, value) {
      $('[name=' + key + ']').val($.makeArray(value));
    });
  }
};

/**
 * Init
 */
(function (Drupal, drupalSettings) {

  NcCourtsPanelFilter.init(Drupal, drupalSettings);

})(Drupal, drupalSettings);



//////////////////
// WEBPACK FOOTER
// ./web/themes/contrib/nccourts-theme/assets/src/js/components/filter-panels.js
// module id = 26
// module chunks = 16